const isMobile = () =>
  /Android|iPhone|iPad|iPod|Mobile|Opera Mini|IEMobile/i.test(navigator.userAgent) ||
  (navigator.maxTouchPoints > 1 && /Macintosh/.test(navigator.userAgent));

function printInNewWindow(html) {
  const url = URL.createObjectURL(new Blob([html], { type: 'text/html;charset=utf-8' }));
  const w = window.open(url, '_blank');
  if (!w) {
    alert('يرجى السماح بالنوافذ المنبثقة في المتصفح');
    URL.revokeObjectURL(url);
    return;
  }
  w.onload = () => setTimeout(() => {
    w.focus();
    w.print();
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  }, 400);
}

function printInIframe(html) {
  const old = document.getElementById('__print_frame');
  if (old && old.parentNode) old.parentNode.removeChild(old);
  const f = document.createElement('iframe');
  f.id = '__print_frame';
  f.setAttribute('aria-hidden', 'true');
  f.style.cssText = 'position:fixed;left:0;top:0;width:0;height:0;border:0;opacity:0;pointer-events:none;';
  document.body.appendChild(f);
  const w = f.contentWindow;
  w.document.open();
  w.document.write(html);
  w.document.close();
  const cleanup = () => setTimeout(() => { if (f.parentNode) f.parentNode.removeChild(f); window.focus(); }, 300);
  setTimeout(() => { try { w.focus(); w.print(); } finally { cleanup(); } }, 500);
}

export default function printHtml(html) {
  if (isMobile()) printInNewWindow(html);
  else printInIframe(html);
}
